module.exports = __webpack_public_path__ + "static/img/2553_phase_function_Paper_Points.aeac7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2553_phase_function_Paper_Points.png
// module id = JG8K
// module chunks = 0